(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["opening-hours"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('opening-hours')) return;

    const WEEKDAY_INDEX = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    const DAY_NAMES = ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'];

    const toMinutes = (value) => {
      const match = /^(\d{1,2}):(\d{2})$/.exec((value || '').trim());
      if (!match) return null;
      return Number(match[1]) * 60 + Number(match[2]);
    };

    class OpeningHours extends HTMLElement {
      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-day]'));
        this.statusElement = this.querySelector('[data-opening-hours-status]');
        this.nextElement = this.querySelector('[data-opening-hours-next]');
        this.update();
        // Een pagina die open blijft staan moet om 10:00 en om 16:00 vanzelf omslaan.
        this.timer = setInterval(() => this.update(), 60000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      // Tijd in de tijdzone van de winkel, niet die van de bezoeker. hourCycle
      // 'h23' en niet hour12: false, want die laatste geeft in sommige browsers
      // 24 terug voor middernacht.
      currentTime() {
        const now = new Date();
        try {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: this.dataset.timezone || undefined,
            weekday: 'short',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
          }).formatToParts(now);
          const value = (type) => (parts.find((part) => part.type === type) || {}).value;
          const day = WEEKDAY_INDEX[value('weekday')];
          const minutes = Number(value('hour')) * 60 + Number(value('minute'));
          if (day !== undefined && !Number.isNaN(minutes)) return { day, minutes };
        } catch (error) {
          // Ongeldige tijdzone-instelling: val terug op de klok van de bezoeker.
        }
        return { day: (now.getDay() + 6) % 7, minutes: now.getHours() * 60 + now.getMinutes() };
      }

      update() {
        const { day, minutes } = this.currentTime();
        const today = this.rows[day];
        const opens = toMinutes(today && today.dataset.open);
        const closes = toMinutes(today && today.dataset.close);
        const openNow = opens !== null && closes !== null && minutes >= opens && minutes < closes;
        const next = openNow ? null : this.nextOpening(day, minutes);

        // Vet alleen is niet genoeg om vandaag aan te wijzen: de tijden van de
        // inloopdagen zijn óók vet, dus dan raadt de bezoeker waar het vet voor
        // staat. Het label zegt het gewoon.
        const todayLabel = this.dataset.todayLabel || 'Vandaag';
        this.rows.forEach((row, index) => {
          const isToday = index === day;
          row.classList.toggle('opening-hours__row--today', isToday);

          const cell = row.querySelector('.opening-hours__day');
          if (!cell) return;
          const marker = cell.querySelector('.opening-hours__today-label');
          if (isToday && !marker) {
            const element = document.createElement('span');
            element.className = 'opening-hours__today-label';
            element.textContent = todayLabel;
            cell.appendChild(element);
          } else if (!isToday && marker) {
            marker.remove();
          }
        });

        if (this.statusElement) {
          let text;
          if (openNow) {
            text = `Nu open — tot ${today.dataset.close}`;
          } else {
            // Bewust géén "Vandaag op afspraak" op afspraakdagen: dat leest als
            // "je kunt nu langskomen", terwijl de winkel op dat moment dicht is.
            // De pil zegt alleen wat er nú geldt; dat het die dag op afspraak kan,
            // staat in de dagenlijst en in de toelichting.
            text = 'Nu gesloten';
            // Staat de zin over de eerstvolgende dag niet aan, dan draagt de pil
            // die informatie zelf — anders zou hij twee keer op het scherm staan.
            if (!this.nextElement && next) text += ` — ${next.when} open vanaf ${next.time}`;
          }
          this.statusElement.textContent = text;
          this.statusElement.dataset.state = openNow ? 'open' : 'closed';
          this.statusElement.hidden = false;
        }

        if (this.nextElement) {
          if (next) this.nextElement.textContent = next.sentence;
          this.nextElement.hidden = !next;
        }
      }

      // Eerste dag vanaf nu waarop de winkel vrij open is. Loopt tot en met
      // offset 7, zodat een winkel die maar één dag per week open is ook een
      // volgende datum krijgt in plaats van niets.
      nextOpening(day, minutes) {
        const label = this.dataset.nextLabel || 'Eerstvolgende dag open';

        for (let offset = 0; offset <= 7; offset += 1) {
          const index = (day + offset) % 7;
          const row = this.rows[index];
          const opens = toMinutes(row && row.dataset.open);
          if (opens === null) continue;
          if (offset === 0 && minutes >= opens) continue;

          const time = row.dataset.open;
          let when;
          if (offset === 0) when = 'vandaag';
          else if (offset === 1) when = 'morgen';
          else if (offset < 7) when = `aanstaande ${DAY_NAMES[index]}`;
          else when = `volgende week ${DAY_NAMES[index]}`;

          let sentence;
          if (offset === 0) sentence = `Vandaag open vanaf ${time}.`;
          else if (offset === 1) sentence = `Morgen weer open vanaf ${time}.`;
          else sentence = `${label}: ${when} vanaf ${time}.`;

          return { offset, time, when, sentence };
        }

        return null;
      }
    }

    customElements.define('opening-hours', OpeningHours);
  })();
  } catch(e) { console.error(e); }
})();

})();
